import { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { bridge, isNotNil } from 'shared/src/utils';
import { AdAction } from 'shared/src/utils/eventLogger/adLogger/types';
import { rankingFilterAtom } from '../states/rankingFilter.atom';
import { getGoodsAnalytics } from './getGoodsAnalytics';
import type { RankingGoodsCardItem } from '../utils/convertRankingGoodsItemToGoodsData';

export const useLogClickLikeGoods = (params: {
  listId: string | undefined;
  listParams: string | undefined;
}) => {
  const filter = useAtomValue(rankingFilterAtom);

  return useCallback(
    (pressed: RankingGoodsCardItem, index: number, isLike: boolean) => {
      const eventType = isLike ? 'CLICK_LIKE_GOODS' : 'CLICK_UNLIKE_GOODS';
      bridge.logAnalyticsEvent({
        name: eventType,
        analytics: getGoodsAnalytics(pressed, index, filter, params, eventType),
      });
      if (isNotNil(pressed.item.ad)) {
        bridge.logAdEvent({
          action: isLike ? AdAction.LIKE : AdAction.UNLIKE,
          ad: pressed.item.ad,
        });
      }
    },
    [filter, params],
  );
};
